import React from 'react';

import { Controller, useFormContext } from 'react-hook-form';

import { IFields } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/MainFilters.types';
import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/Filters.module.scss';
import { Select } from 'components/DesignSystem/Select';

export const Cluster = ({ isSelected, options, onFiltersChanged, isLoading }) => {
    const { control } = useFormContext<IFields>();
    return isSelected ? (
        <div className={classes.selectWrapper}>
            <span className={classes.title}>Cluster</span>
            <Controller
                render={({ field }) => (
                    <Select<ISelectOption<number>>
                        {...field}
                        onChange={(newValue) => {
                            field.onChange(newValue);
                            onFiltersChanged({ [field.name]: newValue });
                        }}
                        id={'battlecards-cluster'}
                        isClearable={true}
                        options={options}
                        isLoading={isLoading}
                    />
                )}
                name={'cluster'}
                control={control}
            />
        </div>
    ) : null;
};
